import React from 'react';

const logoSrc = `${process.env.PUBLIC_URL || ''}/images/cyberwell-logo.png`;

export default function AWatchLoadingScreen({ message = 'Loading...', className = '' }) {
  return (
    <div
      className={`app-loading-screen-card ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="entities-loading-spinner">
        <div className="spinner" />
      </div>
      <img src={logoSrc} alt="CyberWell" className="app-loading-brand-logo" />
      <p className="app-loading-status-text">{message}</p>
    </div>
  );
}
